// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_5n-2";
export var blackBorderOnHover = "_5n-7";
export var cell = "_5n-6";
export var cellContainer = "_5n-3";
export var checked = "_5n-8";
export var disabled = "_5n-5";
export var featuredIconCellContainer = "_5n-9";
export var featuredIconTextContainer = "_5n-b";
export var featuredIconWrapper = "_5n-a";
export var noBorder = "_5n-c";
export var orangeSelectedRow = "_e9-3";
export var overflowableText = "_5n-0";
export var overflowableTextContainer = "_5n-1";
export var row = "_5o-0";
export var rowCheckboxCell = "_5n-4";
export var selectableTable = "_e9-2";